import OnlineUsers from './component'

export default OnlineUsers